function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9199 0H75.1199C77.3291 0 79.1199 1.79086 79.1199 4V40.3333H23.9199V0Z",
  fill: "#D8DDEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1201 4C10.1201 1.79086 11.911 0 14.1201 0H56.7201C58.9293 0 60.7201 1.79086 60.7201 4V40.3333H10.1201V4Z",
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 40.3334,
  width: 92,
  height: 3.66666,
  rx: 1.83333,
  fill: "#F5F8FA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 23.9199,
  y: 13.75,
  width: 22.08,
  height: 12.8333,
  rx: 4,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 27.6001,
  y: 16.5,
  width: 1.84,
  height: 7.33333,
  rx: 0.92,
  fill: "#D8DDEB"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 31.2798,
  y: 16.5,
  width: 3.68,
  height: 7.33333,
  rx: 1.84,
  fill: "#D8DDEB"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 36.7998,
  y: 16.5,
  width: 1.84,
  height: 7.33333,
  rx: 0.92,
  fill: "#D8DDEB"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 40.48,
  y: 16.5,
  width: 1.84,
  height: 7.33333,
  rx: 0.92,
  fill: "#D8DDEB"
});

function SvgOnePackageWithBarcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 44,
    viewBox: "0 0 92 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = React.forwardRef(SvgOnePackageWithBarcode);
export default __webpack_public_path__ + "static/media/one-package-with-barcode.f6998d49.svg";
export { ForwardRef as ReactComponent };